
import ImportGoodsDetail from "@/store/modules/shipment/declarecustoms/importgoodsdetail";
import { Component, FormModalMixins } from "@/lib";

@Component
export default class ImportGoodsDetailModal extends FormModalMixins  {
  model = new ImportGoodsDetail();
  downloadTemplateLoading: boolean = false;

  get record() {
    return this.$store.state.shipment.declarecustoms.importGoodsDetail
  }
  created() {
      Object.assign(this.config, {
        modelTitleL: "app.DeclareCustoms.ImportGoodsDetail",
        labelWidth: 100,
        width: 600,
        okAction: "shipment/declarecustoms/importExportGoodsDetail"
      });
  }
  async downloadTemplate() {
    this.downloadTemplateLoading = true;
    try {
      let response = await this.$store.dispatch({
        type: "shipment/declarecustoms/downloadImportGoodsDetailTemplate"
      });
      let name = "出口货物明细单模版.xlsx";
      this.$util.downloadFile(response.data, name);
    } catch (error) {
      this.$Message.error("下载模板失败");
    } finally {
      this.downloadTemplateLoading = false;
    }
  }
  close() {
      this.config.isShow = false;
      this.model = new ImportGoodsDetail();
  }
  saveError() {
      this.model = new ImportGoodsDetail();
  }
}
